// API Configuration for GPhotoPlus Frontend
// This file centralizes the backend API URL configuration

// Get the API URL from environment variable or use default
const getApiUrl = (): string => {
  // In development, use the environment variable if set
  const viteApiUrl = (import.meta as any).env?.VITE_API_URL;
  if (viteApiUrl) {
    return viteApiUrl;
  }
  
  // In production Docker environment, use the backend service name
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    // Local development - backend runs on port 3001
    return 'http://localhost:3001';
  }
  
  // Default fallback - assume backend is on same host but different port
  return `${window.location.protocol}//${window.location.hostname}:3001`;
};

// Export the base API URL
export const API_BASE_URL = getApiUrl();

// Helper function to build full API URLs
export const buildApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/api/${cleanEndpoint}`;
};

// Common API endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: buildApiUrl('auth/login'),
  REGISTER: buildApiUrl('auth/register-user'),
  EDIT_USER: buildApiUrl('auth/edit-user'),
  RESET_PASSWORD: buildApiUrl('auth/reset-password'),
  AUTH_DELETE_USER: buildApiUrl('auth/delete-user'),
  TOGGLE_MULTIPLE_TASKS: (username: string) => buildApiUrl(`auth/toggle-multiple-tasks/${username}`),
  
  // Tasks
  TASKS_ALL: buildApiUrl('tasks/all'),
  TASKS_CREATE: buildApiUrl('tasks/create'),
  TASKS_RANDOM_PICK: buildApiUrl('tasks/random-pick'),
  TASKS_DOWNLOAD_COMPRESSED: (taskId: string) => buildApiUrl(`tasks/${taskId}/download-compressed`),
  TASKS_DOWNLOAD_CONFIRM: (taskId: string) => buildApiUrl(`tasks/${taskId}/download-confirm`),
  TASKS_SET_PRIORITY: (taskId: string) => buildApiUrl(`tasks/${taskId}/set-priority`),
  TASKS_DELETE: (taskId: string) => buildApiUrl(`tasks/${taskId}`),
  TASKS_SET_DONE: (taskId: string) => buildApiUrl(`tasks/${taskId}/set-done`),
  TASKS_SET_RE_SOLVED: (taskId: string) => buildApiUrl(`tasks/${taskId}/set-re-solved`),
  TASKS_FOLDER_UPLOAD: (taskId: string) => buildApiUrl(`tasks/${taskId}/folder-upload`),
  TASKS_FINALIZE_UPLOAD: (taskId: string) => buildApiUrl(`tasks/${taskId}/finalize-upload`),
  TASKS_CHECK_FOLDER_EXISTS: buildApiUrl('tasks/upload/check-folder-exists'),
  TASKS_IMPORT_EXCEL: buildApiUrl('tasks/import-excel'),
  TASKS_IMPORT_EXCEL_TEMPLATE: buildApiUrl('tasks/import-excel/template'),
  TASKS_IMPORT_GOOGLE_SHEET: buildApiUrl('tasks/import-google-sheet'),
  CATEGORIES_ALL: buildApiUrl('tasks/categories'),
  
  // Teams
  TEAMS_ALL: buildApiUrl('teams'),
  
  // Data
  DATA_A: buildApiUrl('data/A'),
  DATA_B: buildApiUrl('data/B'),
  DATA_C: buildApiUrl('data/C'),
  DATA_AVAILABLE: buildApiUrl('data/available'),
  
};

console.log('API Configuration loaded:', {
  API_BASE_URL,
  environment: (import.meta as any).env?.MODE || 'development',
  viteApiUrl: (import.meta as any).env?.VITE_API_URL || 'not set'
}); 